<template>

    <span class="dropdown-header mt-3"
        v-if="checkGuard('view_institution') || checkGuard('view_division') || checkGuard('view_secteur') || checkGuard('view_recipient_service') || checkGuard('view_agent_in_charge') || checkGuard('view_no_follow_up_reason') || checkGuard('view_recipient') || checkGuard('view_role') || checkGuard('view_user')">Administration</span>
    <small class="bi-three-dots nav-subtitle-replacer"></small>

    <!-- Collapse -->
    <div class="nav-item" v-if="checkGuard('view_role') || checkGuard('view_user')">
        <a class="nav-link dropdown-toggle " href="#navbarVerticalMenuPagesUserMenu" role="button"
            data-bs-toggle="collapse" data-bs-target="#navbarVerticalMenuPagesUserMenu" aria-expanded="true"
            aria-controls="navbarVerticalMenuPagesUserLink"
            :class="routesActive.user_profil.includes($route.name) ? 'active' : 'collapsed'">
            <i class="bi-people nav-icon"></i>
            <span class="nav-link-title">Utilisateurs et Profils</span>
        </a>

        <div id="navbarVerticalMenuPagesUserMenu" class="nav-collapse collapse "
            :class="routesActive.user_profil.includes($route.name) ? 'show' : ''"
            data-bs-parent="#navbarVerticalMenuPagesUserLink">
            <router-link :to="{ name: 'AdminUserProfileProfile' }" v-if="checkGuard('view_role')" active-class="active"
                class="nav-link">Profils</router-link>
            <router-link :to="{ name: 'AdminUserProfileUser' }" v-if="checkGuard('view_user')" active-class="active"
                class="nav-link">Utilisateurs</router-link>
        </div>
    </div>
    <!-- End Collapse -->


    <!-- Collapse -->


    <div class="nav-item"
        v-if="checkGuard('view_institution') || checkGuard('view_division') || checkGuard('view_secteur') || checkGuard('view_recipient_service') || checkGuard('view_agent_in_charge') || checkGuard('view_no_follow_up_reason') || checkGuard('view_recipient')">
        <a class="nav-link dropdown-toggle  collapsed " href="#navbarVerticalMenuPagesConfigMenu" role="button"
            data-bs-toggle="collapse" data-bs-target="#navbarVerticalMenuPagesConfigMenu" aria-expanded="false"
            aria-controls="navbarVerticalMenuPagesConfigLink"
            :class="routesActive.config.includes($route.name) ? 'active' : 'collapsed'">
            <i class="bi-gear nav-icon"></i>
            <span class="nav-link-title">Configuration</span>
        </a>

        <div id="navbarVerticalMenuPagesConfigMenu" class="nav-collapse collapse"
            data-bs-parent="#navbarVerticalMenuPagesConfigLink"
            :class="routesActive.config.includes($route.name) ? 'show' : ''">

            <router-link :to="{ name: 'AdminPointFocal' }" v-if="checkGuard('view_user')" active-class="active"
                class="nav-link">Point Focal</router-link>

            <router-link :to="{ name: 'AdminConfigInstitution' }" v-if="checkGuard('view_institution')"
                active-class="active" class="nav-link ">Institutions</router-link>

            <router-link :to="{ name: 'AdminConfigDivision' }" v-if="checkGuard('view_division')" active-class="active"
                class="nav-link  ">Divisions</router-link>

            <router-link :to="{ name: 'AdminConfigSecteur' }" v-if="checkGuard('view_secteur')" active-class="active"
                class="nav-link">Secteurs</router-link>

            <router-link :to="{ name: 'AdminConfigService' }" v-if="checkGuard('view_recipient_service')"
                active-class="active" class="nav-link">Services</router-link>

            <router-link :to="{ name: 'AdminConfigAgent' }" active-class="active"
                v-if="checkGuard('view_agent_in_charge')" class="nav-link">Agents</router-link>

            <router-link :to="{ name: 'AdminConfigMotif' }" active-class="active"
                v-if="checkGuard('view_no_follow_up_reason')" class="nav-link  ">Motifs du Sans suite</router-link>

            <router-link :to="{ name: 'AdminConfigCaracterisation' }" active-class="active"
                class="nav-link  ">Caractérisation</router-link>

            <router-link :to="{ name: 'AdminConfigAffectation' }" active-class="active"
                v-if="checkGuard('view_recipient')" class="nav-link">Type d'affectation</router-link>

            <router-link :to="{ name: 'AdminConfigParametre' }" active-class="active"
                class="nav-link">Paramètres</router-link>
        </div>
    </div>

    <div class="nav-item">
        <a @click="getHelp" class="nav-link">
            <i class="bi-question-circle nav-icon"></i>
            <span class="nav-link-title">Aide</span>
        </a>
    </div>


</template>
<script>
import { checkGuard } from "@/utils/guards.js"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdmininstrationNavbar",
    data() {
        return {

            routesActive: {
                user_profil: ["AdminUserProfileProfile", "AdminUserProfileUser"],
                config: ["AdminPointFocal,AdminConfigAgent", "AdminConfigDivision", "AdminConfigInstitution", "AdminConfigSecteur", "AdminConfigService", "AdminConfigMotif", "AdminConfigAffectation", "AdminConfigParametre", "AdminConfigCaracterisation"]
            }
        }
    },
    computed: {
        ...mapFields("rapport/info", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            item: "item",
            params: "params",
        }),
    },

    methods: {
        checkGuard,
        ...mapActions({
            getHelp: "rapport/info/getHelp",
            reset: "rapport/info/resetData",
        }),
    },

    unmounted() {
        this.reset();
    },

}
</script>